import React from "react";
import { createRoot } from "react-dom/client";
import AircraftCharterData from "./AircraftCharterData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAircraftCharterData: unknown;
	}
}

export function renderAircraftCharterData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AircraftCharterData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAircraftCharterData = renderAircraftCharterData;
